var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlideControll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2551 2.70001L20.3018 0.653269C21.1684 -0.213369 22.5698 -0.213369 23.4272 0.653269L41.35 18.5669C42.2167 19.4335 42.2167 20.8349 41.35 21.6923L23.4272 39.6151C22.5606 40.4817 21.1592 40.4817 20.3018 39.6151L18.255 37.5684C17.3792 36.6925 17.3976 35.2635 18.2919 34.406L29.4015 23.822L2.9045 23.822C1.6783 23.822 0.691805 22.8355 0.691805 21.6093L0.691805 18.6591C0.691805 17.4329 1.6783 16.4464 2.9045 16.4464L29.4015 16.4464L18.2919 5.86232C17.3884 5.0049 17.37 3.57586 18.2551 2.70001Z",
    fill: "#CFD3D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideControll);
export default __webpack_public_path__ + "static/media/slideControll.7af96e4c3aa1f7da1281509353d6d1c7.svg";
export { ForwardRef as ReactComponent };